import { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import {
  getPrintingRecheckList,
  updateConfig,
} from "../../../store/slices/Printing/printingSlice";
// import { startTimerRecheck } from "../api"; // Timer feature disabled
import { toast } from "react-toastify";

const usePrintingRecheck = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [activeCard, setActiveCard] = useState({ id: "", key: "" });
  const [pendingPage, setPendingPage] = useState(1);
  const visitingOneFrontPrintRef2 = useRef();
  const visitingOneBackPrintRef = useRef();
  const papperFrontPrintRef = useRef();
  const papperBackPrintRef = useRef();
  const bigFrontPrintRef = useRef();
  const vistingDuplexRef = useRef();
  const papperDuplexRef = useRef();
  const foldableCardRef = useRef(null);
  const dispatch = useDispatch();
  const printingState = useSelector((state) => state.printing);
  const slug = sessionStorage?.getItem("slug");
  const [clickedCardId, setClickedCardId] = useState(null);

  useEffect(() => {
    let params = {
      page: pendingPage,
      per_page: 10,
      process_slug: slug,
      search: printingState.searchRecheck,
    };
    dispatch(getPrintingRecheckList(params));
    // eslint-disable-next-line
  }, [pendingPage, printingState.currentPageSize]);

  useEffect(() => {
    dispatch(
      getPrintingRecheckList({
        page: 1,
        per_page: 10,
        process_slug: slug,
      }),
    );
    dispatch(
      updateConfig((state) => {
        state.searchRecheck = "";
        state.search = "";
        state.showTable = false;
      }),
    );
  }, [slug]);

  const handleSearchInput = (e) => {
    const searchValue = e.target.value;
    dispatch(updateConfig((state) => (state.searchRecheck = searchValue)));
  };

  const handleSearch = () => {
    const searchValue = printingState?.searchRecheck;
    dispatch(
      updateConfig((state) => {
        state.cardRecheckData.Pending = [];
      }),
    );
    dispatch(
      getPrintingRecheckList({
        search: searchValue,
        page: 1,
        process_slug: slug,
      }),
    );
  };

  // Timer feature disabled
  // const startTimerPrinting = (item) => {
  //   setClickedCardId(item?._id);
  //   if (!item?._id || clickedCardId === item._id) {
  //     return;
  //   }
  //   let body = {
  //     receipt_id: item?._id,
  //     process_slug: slug,
  //     order_type: 2,
  //   };
  //   startTimerRecheck(body).then((response) => {
  //     if (response?.data?.status_code === 200) {
  //       toast.success("Timer Started");
  //     } else {
  //       toast.error("Can't Start Timer");
  //     }
  //   });
  // };

  const handleCardClick = (e) => {
    setActiveCard({ id: e._id, key: "Pending" });
    // startTimerPrinting(e); // Timer feature disabled
    dispatch(
      updateConfig((state) => {
        state.showTable = true;
        state.selectedId = [e?._id];
        state.gli_id = e?.gli_number;
        state.currentRecheckPage = 1;
        state.isMultiPrint = false;
        state.is_multi_print = false;
        state.gliform = {
          certificate_type: "",
          side: "",
          card_size: { name: "Normal (7.8)", id: 1 },
          remarks: "",
          certificate_format: "",
          gli_data: [
            { gli_number: null, status: [], report_id: null, _id: null },
          ],
          item_type: "",
          gli: [],
          is_multi_print: false,
          is_multi_print_confirm: false,
        };
        state.multipleTableData = {};
        state.multipleTableAllData = [];
        state.transformedGliDataOrder = {};
      }),
    );
    const timmerId = setTimeout(() => {
      dispatch(updateConfig((state) => (state.clear = false)));
      clearTimeout(timmerId);
    }, 100);
  };

  const handleModalClick = () => {
    dispatch(
      updateConfig((state) => {
        state.printModal = !state.printModal;
      }),
    );
  };
  const handleLoadMore = (mouseHover) => {
    if (
      mouseHover === "Pending" &&
      printingState?.cardRecheckData?.Pending?.length <=
        printingState?.total?.Pending
    ) {
      setPendingPage(pendingPage + 1);
      setIsLoading(false);
    }
  };

  const handleMultiClick = (status) => {
    dispatch(
      updateConfig((state) => {
        state.isMultiGliPrint = !state.isMultiGliPrint;
        state.isMultiPrint = status ? true : false;
      }),
    );
  };
  return {
    visitingOneFrontPrintRef2,
    visitingOneBackPrintRef,
    papperFrontPrintRef,
    papperBackPrintRef,
    bigFrontPrintRef,
    vistingDuplexRef,
    papperDuplexRef,
    foldableCardRef,
    cardRecheckData: printingState?.cardRecheckData,
    totalLength: { Pending: printingState.total.Pending },
    printingState,
    apiStatus: { Pending: printingState?.RecheckPendingCardStatus },
    isLoading,
    activeCard,
    handleSearchInput,
    handleSearch,
    setIsLoading,
    handleCardClick,
    handleMultiClick,
    handleLoadMore,
    handleModalClick,
  };
};

export default usePrintingRecheck;
